import './Updates.css';
import { Box, Chip, Container, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CHANGELOG } from 'data/changelog';
import { TYPE_COLORS } from 'utils/constants';

type Lang = 'es' | 'en';

const Updates = () => {
  const { t, i18n } = useTranslation();
  const lang: Lang = i18n.language === 'es' ? 'es' : 'en';

  return (
    <div className="section-updates">
      <Container className="updates-container" maxWidth="md">

        <Typography className='updates-title' variant="h3" component="h1" fontWeight={700} gutterBottom>
          {t('updates.pageTitle')}
        </Typography>
        <Typography className="updates-subtitle" variant="subtitle1">
          {t('updates.pageSubtitle')}
        </Typography>

        {CHANGELOG.map((entry, index) => (
          <Box key={entry.version} className="updates-entry">
            <div className="updates-entry-header">
              <Typography variant="h5" fontWeight={700}>
                {t('updates.version')} {entry.version}
              </Typography>
              <Typography className="updates-entry-date" variant="caption">
                {entry.date}
              </Typography>
            </div>

            <Divider className="updates-divider" />

            <div className="updates-items-list">
              {entry.items.map((item, i) => (
                <div key={i} className="updates-item">
                  <Chip
                    className="updates-chip"
                    label={t(`updates.types.${item.type}`)}
                    size="small"
                    sx={{
                      backgroundColor: `${TYPE_COLORS[item.type]}22`,
                      color: TYPE_COLORS[item.type],
                      border: `1px solid ${TYPE_COLORS[item.type]}55`,
                    }}
                  />
                  <Typography className="updates-item-text" variant="body1">
                    {item[lang]}
                  </Typography>
                </div>
              ))}
            </div>

            {index < CHANGELOG.length - 1 && <Box sx={{ mt: 4 }} />}
          </Box>
        ))}

      </Container>
    </div>
  );
};

export default Updates;
